/**
 * Utility for building dropdown options from bill data
 */
export class BillDropdownOptionsBuilder {
  /**
   * Build dropdown options for Payee, Vendor, Treating Provider, and Bill Status
   * from an array of bills
   */
  static buildOptions(bills: any[]): {
    payeeOptions: { label: string; key: string }[];
    vendorOptions: { label: string; key: string }[];
    treatingOptions: { label: string; key: string }[];
    billStatusOptions: { label: string; key: string }[];
  } {
    return {
      payeeOptions: this.createOptionsFromField(bills, 'payee'),
      vendorOptions: this.createOptionsFromField(bills, 'vendorName'),
      treatingOptions: this.createOptionsFromField(bills, 'treatingProvider'),
      billStatusOptions: this.createOptionsFromField(bills, 'billStatus'),
    };
  }

  /**
   * Create dropdown options from a specific field in the bills array
   */
  private static createOptionsFromField(
    bills: any[],
    field: string,
  ): { label: string; key: string }[] {
    const uniqueValues = this.getUniqueValues(bills, field);
    return this.createOptionsArray(uniqueValues);
  }

  /**
   * Get unique values from bills array for a specific field
   */
  private static getUniqueValues(bills: any[], field: string): string[] {
    const values = bills
      .map((bill) => bill[field])
      .filter((value) => value != null && value !== '' && value !== 'N/A');
    return [...new Set(values)].sort();
  }

  /**
   * Create options array with 'ALL' as first option
   */
  private static createOptionsArray(
    values: string[],
  ): { label: string; key: string }[] {
    return [
      { label: 'All', key: 'ALL' },
      ...values.map((value) => ({ label: value, key: value })),
    ];
  }
}
